import {
  createBackendRouteInvoker,
  resolveTransportForRoute,
} from '../../../../shared/backend/invoke';
import { routeTable } from './routes';
import { invokeCallableRoute } from './transports/callable';
import { invokeHttpRoute } from './transports/http';

export { resolveTransportForRoute };

export const invokeBackendRoute = createBackendRouteInvoker({
  routeTable,
  invokeCallableRoute,
  invokeHttpRoute,
});
